export default __webpack_public_path__ + "static/media/6.edc89d00.mp3";